"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Minda Adapter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MindaAdapterOauthApi = exports.MindaAdapterOauthApiFactory = exports.MindaAdapterOauthApiFp = exports.MindaAdapterOauthApiAxiosParamCreator = exports.MindaAdapterApi = exports.MindaAdapterApiFactory = exports.MindaAdapterApiFp = exports.MindaAdapterApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * MindaAdapterApi - axios parameter creator
 * @export
 */
var MindaAdapterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Find farm minda config.
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmMindaConfig: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('findFarmMindaConfig', 'farmId', farmId);
                    localVarPath = "/minda-adapter/farms/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * ID of the farm to fetch animals from Minda.
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmAnimals: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmAnimals', 'farmId', farmId);
                    localVarPath = "/minda-adapter/farms/".concat(farmId, "/animals")
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId FarmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMindaData: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('ingestMindaData', 'farmId', farmId);
                    localVarPath = "/minda-adapter/herd-management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (farmId !== undefined) {
                        localVarQueryParameter['farmId'] = farmId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId Run job for the given farm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerIngestPregnancyResults: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('triggerIngestPregnancyResults', 'farmId', farmId);
                    localVarPath = "/minda-adapter/update-pregnancy-results";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (farmId !== undefined) {
                        localVarQueryParameter['farmId'] = farmId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm minda config.
         * @param {string} farmId
         * @param {IUpdateFarmMindaConfigDTO} [iUpdateFarmMindaConfigDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmMindaConfig: function (farmId, iUpdateFarmMindaConfigDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmMindaConfig', 'farmId', farmId);
                    localVarPath = "/minda-adapter/farms/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmMindaConfigDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MindaAdapterApiAxiosParamCreator = MindaAdapterApiAxiosParamCreator;
/**
 * MindaAdapterApi - functional programming interface
 * @export
 */
var MindaAdapterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MindaAdapterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Find farm minda config.
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmMindaConfig: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findFarmMindaConfig(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ID of the farm to fetch animals from Minda.
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmAnimals: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmAnimals(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId FarmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMindaData: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ingestMindaData(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId Run job for the given farm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerIngestPregnancyResults: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerIngestPregnancyResults(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm minda config.
         * @param {string} farmId
         * @param {IUpdateFarmMindaConfigDTO} [iUpdateFarmMindaConfigDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmMindaConfig: function (farmId, iUpdateFarmMindaConfigDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmMindaConfig(farmId, iUpdateFarmMindaConfigDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MindaAdapterApiFp = MindaAdapterApiFp;
/**
 * MindaAdapterApi - factory interface
 * @export
 */
var MindaAdapterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MindaAdapterApiFp)(configuration);
    return {
        /**
         * Find farm minda config.
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmMindaConfig: function (farmId, options) {
            return localVarFp.findFarmMindaConfig(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ID of the farm to fetch animals from Minda.
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmAnimals: function (farmId, options) {
            return localVarFp.getFarmAnimals(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId FarmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMindaData: function (farmId, options) {
            return localVarFp.ingestMindaData(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId Run job for the given farm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerIngestPregnancyResults: function (farmId, options) {
            return localVarFp.triggerIngestPregnancyResults(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm minda config.
         * @param {string} farmId
         * @param {IUpdateFarmMindaConfigDTO} [iUpdateFarmMindaConfigDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmMindaConfig: function (farmId, iUpdateFarmMindaConfigDTO, options) {
            return localVarFp.updateFarmMindaConfig(farmId, iUpdateFarmMindaConfigDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MindaAdapterApiFactory = MindaAdapterApiFactory;
/**
 * MindaAdapterApi - object-oriented interface
 * @export
 * @class MindaAdapterApi
 * @extends {BaseAPI}
 */
var MindaAdapterApi = /** @class */ (function (_super) {
    __extends(MindaAdapterApi, _super);
    function MindaAdapterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Find farm minda config.
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterApi
     */
    MindaAdapterApi.prototype.findFarmMindaConfig = function (farmId, options) {
        var _this = this;
        return (0, exports.MindaAdapterApiFp)(this.configuration).findFarmMindaConfig(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ID of the farm to fetch animals from Minda.
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterApi
     */
    MindaAdapterApi.prototype.getFarmAnimals = function (farmId, options) {
        var _this = this;
        return (0, exports.MindaAdapterApiFp)(this.configuration).getFarmAnimals(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId FarmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterApi
     */
    MindaAdapterApi.prototype.ingestMindaData = function (farmId, options) {
        var _this = this;
        return (0, exports.MindaAdapterApiFp)(this.configuration).ingestMindaData(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId Run job for the given farm id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterApi
     */
    MindaAdapterApi.prototype.triggerIngestPregnancyResults = function (farmId, options) {
        var _this = this;
        return (0, exports.MindaAdapterApiFp)(this.configuration).triggerIngestPregnancyResults(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm minda config.
     * @param {string} farmId
     * @param {IUpdateFarmMindaConfigDTO} [iUpdateFarmMindaConfigDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterApi
     */
    MindaAdapterApi.prototype.updateFarmMindaConfig = function (farmId, iUpdateFarmMindaConfigDTO, options) {
        var _this = this;
        return (0, exports.MindaAdapterApiFp)(this.configuration).updateFarmMindaConfig(farmId, iUpdateFarmMindaConfigDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MindaAdapterApi;
}(base_1.BaseAPI));
exports.MindaAdapterApi = MindaAdapterApi;
/**
 * MindaAdapterOauthApi - axios parameter creator
 * @export
 */
var MindaAdapterOauthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to retrieve the authorization entry point for the MINDA consent flow.
         * @param {string} redirectUrl URL supplied by the client to be redirected when the oauth flow has completed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterAuthorization: function (redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'redirectUrl' is not null or undefined
                    (0, common_1.assertParamExists)('enterAuthorization', 'redirectUrl', redirectUrl);
                    localVarPath = "/minda-adapter/oauth/authorize";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirectUrl'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Callback API for the MINDA auth consent flow.
         * @param {string} state State string that was originally passed at the beginning of the consent flow, this will contain encoded Halter user information.
         * @param {string} code Authorization code that can be used to request a user token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCallback: function (state, code, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'state' is not null or undefined
                    (0, common_1.assertParamExists)('receiveCallback', 'state', state);
                    // verify required parameter 'code' is not null or undefined
                    (0, common_1.assertParamExists)('receiveCallback', 'code', code);
                    localVarPath = "/minda-adapter/oauth/callback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MindaAdapterOauthApiAxiosParamCreator = MindaAdapterOauthApiAxiosParamCreator;
/**
 * MindaAdapterOauthApi - functional programming interface
 * @export
 */
var MindaAdapterOauthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MindaAdapterOauthApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to retrieve the authorization entry point for the MINDA consent flow.
         * @param {string} redirectUrl URL supplied by the client to be redirected when the oauth flow has completed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterAuthorization: function (redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.enterAuthorization(redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Callback API for the MINDA auth consent flow.
         * @param {string} state State string that was originally passed at the beginning of the consent flow, this will contain encoded Halter user information.
         * @param {string} code Authorization code that can be used to request a user token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCallback: function (state, code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.receiveCallback(state, code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MindaAdapterOauthApiFp = MindaAdapterOauthApiFp;
/**
 * MindaAdapterOauthApi - factory interface
 * @export
 */
var MindaAdapterOauthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MindaAdapterOauthApiFp)(configuration);
    return {
        /**
         * Endpoint to retrieve the authorization entry point for the MINDA consent flow.
         * @param {string} redirectUrl URL supplied by the client to be redirected when the oauth flow has completed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterAuthorization: function (redirectUrl, options) {
            return localVarFp.enterAuthorization(redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Callback API for the MINDA auth consent flow.
         * @param {string} state State string that was originally passed at the beginning of the consent flow, this will contain encoded Halter user information.
         * @param {string} code Authorization code that can be used to request a user token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCallback: function (state, code, options) {
            return localVarFp.receiveCallback(state, code, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MindaAdapterOauthApiFactory = MindaAdapterOauthApiFactory;
/**
 * MindaAdapterOauthApi - object-oriented interface
 * @export
 * @class MindaAdapterOauthApi
 * @extends {BaseAPI}
 */
var MindaAdapterOauthApi = /** @class */ (function (_super) {
    __extends(MindaAdapterOauthApi, _super);
    function MindaAdapterOauthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to retrieve the authorization entry point for the MINDA consent flow.
     * @param {string} redirectUrl URL supplied by the client to be redirected when the oauth flow has completed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterOauthApi
     */
    MindaAdapterOauthApi.prototype.enterAuthorization = function (redirectUrl, options) {
        var _this = this;
        return (0, exports.MindaAdapterOauthApiFp)(this.configuration).enterAuthorization(redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Callback API for the MINDA auth consent flow.
     * @param {string} state State string that was originally passed at the beginning of the consent flow, this will contain encoded Halter user information.
     * @param {string} code Authorization code that can be used to request a user token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MindaAdapterOauthApi
     */
    MindaAdapterOauthApi.prototype.receiveCallback = function (state, code, options) {
        var _this = this;
        return (0, exports.MindaAdapterOauthApiFp)(this.configuration).receiveCallback(state, code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MindaAdapterOauthApi;
}(base_1.BaseAPI));
exports.MindaAdapterOauthApi = MindaAdapterOauthApi;
